import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Logo.css';

const Logo = ({
  src,
  isSquare = true
}) => {
  return (
    <img
      className={classNames('Logo', {
        'Logo--square': isSquare
      })}
      src={src}
    />
  );
}

Logo.propTypes = {
  src: PropTypes.string,
  isSquare: PropTypes.bool
};

export default Logo;
